import { useEffect, useRef, useState } from 'react';
import { usePageDetailsContext } from '../contexts/page-details-context/page-details-context';

const useLockScroll = () => {
  const scrollTop = useRef(0);
  const [isLocked, setIsLocked] = useState(false);
  const { handleUpdateIsScrolled } = usePageDetailsContext();

  useEffect(() => {
    if (isLocked) {
      scrollTop.current = document.documentElement.scrollTop;

      document.body.style.position = 'fixed';
      document.body.style.overflowY = 'scroll';
      document.body.style.top = `-${scrollTop.current}px`;
      document.body.style.width = '100%';
      handleUpdateIsScrolled(false);
    } else {
      document.documentElement.scrollTop = scrollTop.current;
      document.body.style.position = '';
      document.body.style.overflowY = '';
      document.body.style.top = '';
      document.body.style.width = '';
      handleUpdateIsScrolled(true);
    }

    return () => {
      document.body.style.position = '';
      document.body.style.overflowY = '';
      document.body.style.top = '';
      document.body.style.width = '';
      handleUpdateIsScrolled(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocked]);

  return {
    isLocked,
    setIsLocked,
  };
};

export default useLockScroll;
